import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../../store';
import CollapsibleSwitchListItem from '../../../../../../../list-items/CollapsibleSwitchListItem';
import CondensedListItem from '../../../../../../../list-items/CondensedListItem';
import ImageElementShadowColorListItem from './ImageElementShadowColorListItem';
import ImageElementShadowBlurListItem from './ImageElementShadowBlurListItem';
import ImageElementShadowOpacityListItem from './ImageElementShadowOpacityListItem';
import ImageElementShadowDistanceListItem from './ImageElementShadowDistanceListItem';
import ImageElementShadowAngleListItem from './ImageElementShadowAngleListItem';

const ImageElementShadowListItem = (props) => {
    const { shadowSettingsEnabled, updateImageElement, index } = props;

    const onShadowEnabledChange = (value) => updateImageElement(index, {
        shadowSettings: { enabled: value }
    });

    return (
        <CollapsibleSwitchListItem
            checked={shadowSettingsEnabled}
            text='Shadow'
            onChange={onShadowEnabledChange}
        >
            <List dense disablePadding>
                <ImageElementShadowColorListItem index={index} />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <ImageElementShadowBlurListItem index={index} />
                        },
                        {
                            width: 6,
                            component: <ImageElementShadowOpacityListItem index={index} />
                        }
                    ]}
                />
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <ImageElementShadowDistanceListItem index={index} />
                        },
                        {
                            width: 6,
                            component: <ImageElementShadowAngleListItem index={index} />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const imageElement = (state.createPreview.present.videoSettings.elements.imageElements || state.createPreview.present.videoSettings.elements.images)[ownProps.index];
    const shadowSettings = imageElement?.shadowSettings || {};
    return { shadowSettingsEnabled: shadowSettings.enabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementShadowListItem);
